import React, { useMemo } from 'react';

import { StyleProp, TextStyle } from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { DETAIL_CAST_CREW, DETAIL_CAST_TITLE } from 'config/testID';

import { CastCrewPerson } from 'store/railsBuilder/reducer.types';

import { ContentType } from 'services/data-manager/types';

import useLocalizedPersonName from 'utils/hooks/useLocalizedPersonName';
import { isWeb } from 'utils/responsiveness';

import Ribbon from 'components/Ribbon';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    castCrew: CastCrewPerson[];
    style?: StyleProp<TextStyle>;
};

const {
    PROGRAM_DETAILS: { PROGRAM_DETAIL_STRIPE_PERSON },
} = LANGUAGE_KEYS;

function DetailCast({ castCrew, style }: Props) {
    const { t } = useTranslation();
    const { getLocalizedPersonName } = useLocalizedPersonName();

    const castPersons = useMemo(
        () =>
            castCrew.map((castPerson) => ({
                name: getLocalizedPersonName(castPerson.names),
                id: castPerson.id,
                image: castPerson.images[0],
            })),
        [castCrew, getLocalizedPersonName],
    );

    return (
        <>
            <Text
                color={ETextColor.neutral}
                category={ETextCategory.title3}
                numberOfLines={1}
                style={[style, styles.title]}
                testID={DETAIL_CAST_TITLE}
                accessibilityRole="text"
                accessible
                {...(isWeb && { tabIndex: 0 })}
            >
                {t(PROGRAM_DETAIL_STRIPE_PERSON)}
            </Text>
            <Ribbon
                testID={DETAIL_CAST_CREW}
                items={castPersons}
                metadataType={ContentType.CastPerson}
            />
        </>
    );
}

export default DetailCast;
